import { FC } from 'react';

import { useIsMutating } from '@tanstack/react-query';

import { InsuranceEntry } from '@telialt/common-order-cart/src/entries/InsuranceEntry';
import { trackRemoveFromCartGA } from '@telialt/gtm-tracking/src/events';
import { useLogErrorEshop } from '@telialt/utils/src/datadog/useLogError';
import {
    selectedInsuranceFranchisePrice,
    selectInsuranceFreePeriod,
    selectInsuranceMonthlyPrice,
} from '@telialt/utils/src/eshopSelectors';

import { useInsuranceMutation } from '../../hooks/mutations/useInsuranceMutation';
import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { ESHOP_MUTATION_KEY } from '../../model';

export const InsuranceEntryConnected: FC<{ showRemove: boolean }> = ({ showRemove }) => {
    const { cart } = useCartQuery();
    const { mutateInsurance, insuranceIsLoading, insuranceError } = useInsuranceMutation();
    const isUpdatingInsurance = useIsMutating({ mutationKey: [ESHOP_MUTATION_KEY.UPDATE_INSURANCE] }) > 0;
    useLogErrorEshop(insuranceError);

    const removeInsurance = () => {
        mutateInsurance(false);
        trackRemoveFromCartGA({ source: 'productInsurance', data: { cart } });
    };

    const freePeriod = selectInsuranceFreePeriod(cart);
    const monthlyPrice = selectInsuranceMonthlyPrice(cart);
    const franchisePrice = selectedInsuranceFranchisePrice(cart);

    return (
        <InsuranceEntry
            monthlyPrice={monthlyPrice}
            freePeriod={freePeriod}
            franchisePrice={franchisePrice}
            onRemove={showRemove ? removeInsurance : undefined}
            isLoading={insuranceIsLoading}
            isDisabled={isUpdatingInsurance}
        />
    );
};
